import React from 'react';
//import { CaretDownOutlined, CaretUpOutlined }  from '@ant-design/icons'
import * as etiquetas from '../../../ApplicationResources';

const VFiltrosText = ({ proceso, estado, distrito, isOpenCombo, handleChangeOpenCombo }) => {
    const etiquetaEstado = estado && estado.nombreEstado ? estado.nombreEstado : "";
    const etiquetaDistrito = distrito && distrito.nombreDistrito ? distrito.nombreDistrito : "";
    const etiquetaIdDistrito = distrito && distrito.idDistrito > 0 ?  distrito.idDistrito+'-' : '';
    const etiquetaNombredetalle = "";

    return(
        <div className={`fmc-text ${isOpenCombo ? 'fmc-text-open' : ''}`}>
            <div className='fmc-text-data'>
                <span className='fmc-text-data-label-estado'>
                    {etiquetas.MENU_FILTROS_ESTADO}
                </span>
                <span className='fmc-text-data-proceso'>
                    {`${etiquetaEstado}`}
                </span>
                <span className='fmc-text-data-label-proceso'>
                    {etiquetas.MENU_FILTROS_PROCESOS}
                </span>
                <span className='fmc-text-data-proceso'>
                    {proceso ? proceso.descripcionDetalleLarga : ''}
                </span>
            </div>
{/*             <div className='fmc-text-icon'
                onClick={handleChangeOpenCombo} >
                {
                    isOpenCombo ? 
                        <CaretUpOutlined />
                    :   <CaretDownOutlined />
                }    
                
            </div> */}
        </div>
    );

}

export default VFiltrosText;